import Slider from "rc-slider";
import "rc-tooltip/assets/bootstrap.css";
import * as React from "react";
import "./SliderTooltip.css";

const TooltipSlider = ({ tipFormatter, tipProps, ...props }) => {
  return (
    <Slider
      {...props}
      handleRender={(renderProps) => (
        <div {...renderProps.props}>
          <div data-slider-tooltip={renderProps.props["aria-valuenow"]} />
        </div>
      )}
    />
  );
};

export default TooltipSlider;
